import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useApolloClient } from "@apollo/react-hooks";
import { userLogout } from "state/actions/user";
import { setIdleTimer } from "state/actions/idleTimer";

export const manualLogout = ({
  apolloClient,
  history,
  dispatch,
  redirectUri,
}) => {
  window.localStorage.removeItem("jwt");
  window.localStorage.removeItem("userId");
  window.localStorage.removeItem("verifyBankInfoDrawerDismissed");
  dispatch(setIdleTimer(false));
  dispatch(userLogout());
  apolloClient.resetStore();
  history.replace(
    redirectUri ? `/login?redirect_uri=${redirectUri}` : "/login",
  );
};

const useWithoutApolloClient = () => {
  const dispatch = useDispatch();
  const apolloClient = useApolloClient();
  const history = useHistory();

  const logout = (redirectUri) => {
    manualLogout({
      apolloClient,
      history,
      dispatch,
      redirectUri,
    });
  };
  return logout;
};

// useWithApolloClient is mainly here because the apolloWrapper needs to be able to log people out but calling
// useLogout in the apolloWrapper would throw an error because the apolloClient context doesn't exist yet

const useWithApolloClient = (apolloClient) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const logout = (redirectUri) => {
    manualLogout({
      apolloClient,
      history,
      dispatch,
      redirectUri,
    });
  };
  return logout;
};

export default ({ apolloClient } = {}) => {
  if (apolloClient) {
    return useWithApolloClient(apolloClient);
  }
  return useWithoutApolloClient();
};
